import PositionDto from "@/models/dto/position.dto";
import DateUtil from "@/utils/date.util";
import DeviceUtil from "@/utils/device.util";

export default class ReportService {
    static formatGenericData(data: PositionDto[]) {
        return data.map(item => {
            return {
                date: DateUtil.getGenericFormat(item.deviceTime),
                address: item.address,
                speed: `${DeviceUtil.formatKnToKmh(item.speed)} Km/h`,
                odometer: DeviceUtil.formatOdometerFromReport(item.attributes.odometer),
                battery: DeviceUtil.formatBattery(item.attributes.power),
                latitude: item.latitude,
                longitude: item.longitude,
                ign: item.attributes.ignition ?? false
            }
        })
    }
}